import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { TabContainer } from "../ServicesTab/servicestab.styled";
import { Header, SummaryTable } from "./Tabs.styled";
import { useState } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import AccountPopup from "./AccountPopup";
import RemoveIcon from "@mui/icons-material/Remove";
import trash from "../../assets/trash.svg";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
// import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { FC, ReactElement } from "react";
import Error from "../error";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { filsToAmount, filsToAmountString, toFils } from "../../utils/money";

interface Obj {
  [key: string]: any;
}

interface Props {
  // GetSummary: ()=>void,
  openAddAccountModal: () => void;
  confirmAndSubmit: (totalAmount: string) => Promise<void>;
  removeConnectorAccount: (a: string) => void;
  removeServiceAccount: (a: string) => void;
  calculatePaymentPlan: () => Promise<void>;
  selectedServiceAccounts: Obj;
  selectedConnectorAccounts: Obj;
  Next: React.MouseEventHandler<HTMLButtonElement>;
  Previous: React.MouseEventHandler<HTMLButtonElement>;
  planLoader:Boolean;
}

const Summary: FC<Props> = ({
  /*GetSummary,*/ openAddAccountModal,
  confirmAndSubmit,
  calculatePaymentPlan,
  removeServiceAccount,
  removeConnectorAccount,
  selectedServiceAccounts,
  selectedConnectorAccounts,
  Next,
  Previous,
  planLoader,
}: Props): ReactElement => {
  /**
   * Derived up front rather than accumulated inside the JSX map: the total used
   * to be built as a render side-effect, so whenever the empty-state branch
   * rendered instead, the validated amount was submitted as 0.00 while the plan
   * itself carried the real figure. Summed in fils so it agrees to the fil with
   * what CreatePayPlan later posts, and parsed with toFils rather than
   * parseFloat, which reads "1,234.56" as 1.
   */
  const positiveBalanceFils = (accounts: Obj): number =>
    Object.values(accounts).reduce((total: number, account: Obj) => {
      const fils = toFils(account?.currentBalance) ?? 0;
      return fils > 0 ? total + fils : total;
    }, 0);

  const totalFils =
    positiveBalanceFils(selectedServiceAccounts) +
    positiveBalanceFils(selectedConnectorAccounts);

  const handleOpen = () => {
    openAddAccountModal();
  };

  const handleConfirm = () => {
    confirmAndSubmit(filsToAmountString(totalFils));
    calculatePaymentPlan();
  };

  const handleGetSummary = async () => {
    // await GetSummary();
  };
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <>
      <TabContainer style={{ width: "100%" }}>
        <Header
          style={{
            margin: "20px 0px",
            flexDirection:General?.isLargeScreen?'row':'column',width:General?.isLargeScreen?'':"100%"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span
              style={{
                fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                fontWeight: "600",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
              {General?.codeLabels["cm_pdc_paymentaccountsummary"]?.label !==
              undefined
                ? General?.codeLabels["cm_pdc_paymentaccountsummary"]?.label
                : "Summary"}
            </span>
            <span
              style={{
                fontSize: `${0.9 * General.accessibility.fontSize}rem`,
                width: "100%",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              }}
            >
             {General?.codeLabels["cm_summary_info"]?.label?General?.codeLabels["cm_summary_info"]?.label:'View and confirm accounts you have added. You can also add other accounts to the list.'}
            </span>
          </div>
          <div style={{ width:General?.isLargeScreen? "25%" :"100%"}}>
            <ButtonSecondary
              onClick={handleOpen}
              style={{
                zIndex: 0,
                padding: "10px",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : ColorAss,
                  width:General?.isLargeScreen?"":"100%",
                  border:"none",
              }}
            >
              {General?.codeLabels["cm_summary_other"]?.label?General?.codeLabels["cm_summary_other"]?.label:'ADD OTHER ACCOUNTS'}
            </ButtonSecondary>
          </div>
        </Header>
        <Error id="validateAmountError" />
        <SummaryTable >
          <thead>
            <tr
              style={{
                background: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
              }}
            >
              <th
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_pdcpaymentaccounts"]?.label !==
                undefined
                  ? General?.codeLabels["cm_pdcpaymentaccounts"]?.label
                  : "Accounts"}
              </th>
              <th
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?"left":"right",
                }}
              >
                {General?.codeLabels["cm_pdc_amountinaed"]?.label !== undefined
                  ? General?.codeLabels["cm_pdc_amountinaed"]?.label
                  : "Amount (AED)"}
              </th>
            </tr>
            <tr
              style={{
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#edf4f6",
              }}
            >
              <th style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
                <span
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                >
                  {" "}
                  {General?.codeLabels["cm_pdc_servicefees"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_pdc_servicefees"]?.label
                    : "Service Fee"}
                </span>
              </th>
              <th onClick={()=>{}} style={{ fontSize: `${General.accessibility.fontSize}rem`,cursor:'pointer', textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?"left":"right", }}>
                <RemoveIcon style={{stroke: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  fill: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,}}  />
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(selectedServiceAccounts).length > 0 ? (
              Object.values(selectedServiceAccounts).map((account) => {
                const amount = filsToAmount(toFils(account.currentBalance) ?? 0);

                return (
                  <tr>
                    <td
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                          
                      }}
                    >
                      
                      {amount > 0 ? amount?.toFixed(2) : 0}
                    </td>
                    <td
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                          textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?"left":"right",
                          
                      }}
                    >
                    {account.accountId}  <img onClick={()=>removeServiceAccount(account.accountId)} style={{cursor:'pointer'}} src={trash} alt="" />
                    </td>
                  </tr>
                );
              })
            ) : (
              <p
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_summary_fee"]?.label?General?.codeLabels["cm_summary_fee"]?.label:'No Service Fees'}
              </p>
            )}
            <tr
              style={{
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#edf4f6",
              }}
            >
              <th style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
                <span
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_pdc_notconnectedfees"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_pdc_notconnectedfees"]?.label
                    : "Connector Fee"}
                </span>
              </th>
              <th
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,

                  textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?"left":"right",
                }}
              >
                <RemoveIcon style={{stroke: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                  fill: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,}} />
              </th>
            </tr>
            {Object.keys(selectedConnectorAccounts).length > 0 ? (
              Object.values(selectedConnectorAccounts).map((account) => {
                const amount = filsToAmount(toFils(account.currentBalance) ?? 0);

                return (
                  <tr
                    style={{
                      background: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "",
                    }}
                  >
                    <td
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                      }}
                    >
                     
                      {amount > 0 ? amount?.toFixed(2) : 0}
                    </td>
                    <td
                      style={{
                        textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?"left":"right",
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : ColorAss,
                      }}
                    >
                    {account.accountId}   
                    <img onClick={()=>removeConnectorAccount(account.accountId)} style={{cursor:'pointer'}} src={trash} alt="" />
                    </td>
                  </tr>
                );
              })
            ) : (
              <p
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_connector_fee"]?.label?General?.codeLabels["cm_connector_fee"]?.label:'No Connector Fees'}
              </p>
            )}
            <tr
              style={{
                background: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
              }}
            >
              <td
                style={{
                  borderTop: "2px solid #101e8e",

                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss,
                  background: contrast?.contrastColor ? contrast?.contrastColor :"rgb(237, 244, 246)",
                  fontWeight: 900,
                }}
                className="NocBorderColor"
              >
                {General?.codeLabels["cm_total1"]?.label !== undefined
                  ? General?.codeLabels["cm_total1"]?.label
                  : "Total"}{" "}
                (AED)
              </td>
              <td
                style={{
                  borderTop: "2px solid #101e8e",
                  textAlign: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"?"left":"right",                  color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss,
                  background: contrast?.contrastColor ? contrast?.contrastColor :"rgb(237, 244, 246)",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  fontWeight: 900,
                }}
                className="NocBorderColor"
              >
                {filsToAmountString(totalFils)}
              </td>
            </tr>
          </tbody>
        </SummaryTable>
        <hr style={{ width: "100%" }} />
        <ButtonsContainer style={{ gridColumn:"1 / span 2",width:General?.isLargeScreen?"":"100%" ,display:General?.isLargeScreen?"":"flex",flexDirection:General?.isLargeScreen?'row':"column"}}>
          <ButtonSecondary
            style={{
              width: General?.isLargeScreen?"35%":"100%",
              padding: "auto",
              fontSize: `${General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor
                ? contrast?.contrastColor
                :ColorAss,
              background: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
                borderColor:contrast?.contrastColor ? contrast?.contrastColor :ColorAss,
            }}
            onClick={Previous}
          >
            {General?.codeLabels["cm_backbutton"]?.label !== undefined
              ? General?.codeLabels["cm_backbutton"]?.label
              : "BACK"}
          </ButtonSecondary>
          <ButtonSecondary
            style={{
              width: General?.isLargeScreen?"60%":"100%",
              padding: "10px 20px",
              fontSize: `${General.accessibility.fontSize}rem`,
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : ColorAss,
                marginTop:General?.isLargeScreen?"":"1rem",
                border:"none",
            }}
            onClick={handleConfirm}
          >
            {planLoader?<Spinner width="30px" height="30px" /> : General?.codeLabels["cm_next"]?.label !== undefined
              ? General?.codeLabels["cm_next"]?.label
              : "NEXT"}
          </ButtonSecondary>
        </ButtonsContainer>
      </TabContainer>
    </>
  );
};

export default observer(Summary);
